import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <div className="main-header-container">
      LoRRI-Profile
    </div>
  );
};

export default Header;
